import React, { createContext, useEffect, useState } from 'react'
import { fetchAndActivate, getValue, fetchConfig } from 'firebase/remote-config'
import { remoteConfig } from '../firebase'
import PropTypes from 'prop-types'

export const RemoteConfigContext = createContext()

export const RemoteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadRemoteConfig = async () => {
      try {
        // Force a fetch from the server before activating
        await fetchConfig(remoteConfig)
        await fetchAndActivate(remoteConfig)
        const googleDrive = getValue(remoteConfig, 'google_drive').asBoolean()
        const oneDrive = getValue(remoteConfig, 'one_drive').asBoolean()
        const zoom = getValue(remoteConfig, 'zoom').asBoolean()
        const dropbox = getValue(remoteConfig, 'dropbox').asBoolean()
        const box = getValue(remoteConfig, 'box').asBoolean()
        const roadmap = getValue(remoteConfig, 'roadmap').asBoolean()
        const slack = getValue(remoteConfig, 'slack').asBoolean()
        const gong = getValue(remoteConfig, 'gong').asBoolean()
        const darkMode = getValue(remoteConfig, 'dark_mode').asBoolean()
        const askAnything = getValue(remoteConfig, 'ask_anything').asBoolean()
        setConfig({ googleDrive, oneDrive, zoom, dropbox, box, roadmap, slack, gong, darkMode, askAnything })
        setIsLoading(false)
      } catch (error) {
        console.error('Error fetching Remote Config:', error)
      }
    }

    loadRemoteConfig()
  }, [remoteConfig])

  return <RemoteConfigContext.Provider value={{ config, isLoading }}>{children}</RemoteConfigContext.Provider>
}

RemoteConfigProvider.propTypes = {
  children: PropTypes.node,
}
